var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "qw",
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "premium (large)",
    filter: "url(#filter0_d_1192_3782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12",
    filter: "url(#filter1_d_1192_3782)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 8,
    r: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 8,
    r: 6,
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3451 10.3232C17.3451 10.1334 17.1892 9.97978 16.9966 9.97978H13.0037C12.811 9.97978 12.6551 10.1334 12.6551 10.3232C12.6551 10.513 12.811 10.6666 13.0037 10.6666H16.9966C17.1892 10.6666 17.3451 10.5124 17.3451 10.3232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3033 7.54353C12.309 7.54353 12.3141 7.54353 12.3198 7.5429L12.8724 9.51342H17.1276L17.6802 7.5429C17.6859 7.5429 17.691 7.54353 17.6967 7.54353C17.9255 7.54353 18.1111 7.36059 18.1111 7.13519C18.1111 6.90979 17.9255 6.72685 17.6967 6.72685C17.4679 6.72685 17.2823 6.90979 17.2823 7.13519C17.2823 7.17889 17.2892 7.22135 17.3025 7.26069L16.3032 7.83636L15.2291 6.08187C15.3406 6.00882 15.4148 5.88332 15.4148 5.74159C15.4148 5.51619 15.2291 5.33325 15.0003 5.33325C14.7716 5.33325 14.5859 5.51619 14.5859 5.74159C14.5859 5.88395 14.6594 6.00882 14.7716 6.08187L13.6975 7.83636L12.6981 7.26069C12.7108 7.22135 12.7184 7.17889 12.7184 7.13519C12.7184 6.90979 12.5327 6.72685 12.304 6.72685C12.0746 6.72685 11.8889 6.90979 11.8889 7.13519C11.8889 7.36059 12.0746 7.54353 12.3033 7.54353Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1192_3782",
    x: 6.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1192_3782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1192_3782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1192_3782",
    x: 0.442307,
    y: -4.06538,
    width: 29.1154,
    height: 29.1154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.49231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.15385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.106944 0 0 0 0 0.107333 0 0 0 0 0.116667 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1192_3782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1192_3782",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium-icon.f2bc8e7cc1756880dfa4ad79a6973892.svg";
export { ForwardRef as ReactComponent };